import { useEffect } from 'react';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../store/store';
import { fetchPayments, fetchFX } from '../store/reducers/paymentSlice';
import { getIntregrations } from '../store/reducers/integrationSlice';
import { getCountries } from '../store/reducers/countriesSlice';
import { fetchStatistics } from '../store/reducers/dashboardSlice';
import { fetchCutOffTime } from '../store/reducers/cutOffTimeSlice';
import { EDirection } from '../store/reducers/enumTypes';

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export function useFetchPayments() {
  const dispatch = useAppDispatch();
  const { filters } = useAppSelector((state) => state.filtersReducer);

  useEffect(() => {
    if (filters.direction === EDirection.FX) {
      dispatch(fetchFX(filters));
    } else {
      dispatch(fetchPayments(filters));
    }
  }, [filters, dispatch]);
}

export function useFetchIntegrations() {
  const dispatch = useAppDispatch();
  const { paramsId } = useAppSelector((state) => state.integrationReducer);
  const { loading } = useAppSelector((state) => state.countriesReducer);

  useEffect(() => {
    if (loading || paramsId !== null) dispatch(getIntregrations());
  }, [dispatch, loading, paramsId]);
}

export function useFetchCountries() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getCountries());
  }, [dispatch]);
}

export function useFetchStatistics() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchStatistics());
  }, [dispatch]);
}

export function useFetchCutOffTime() {
  const dispatch = useAppDispatch();
  const { paramsId } = useAppSelector((state) => state.integrationReducer);
  const { ccyId, loading } = useAppSelector((state) => state.cutOffTimeReducer);

  useEffect(() => {
    loading && setTimeout(() => dispatch(fetchCutOffTime({ paramsId: paramsId || '' })), 100);
  }, [dispatch, paramsId, ccyId, loading]);
}